module.exports = __webpack_public_path__ + "img/MG.3bb33f8d.svg";